import React from 'react'

// Import styled components
import { GameItem } from './GamesResponsive'

export default ({ dataLength, children }) => (
  <GameItem dataLength={dataLength}>{children}</GameItem>
)



// WEBPACK FOOTER //
// ./src/components/sections/games/GameItem.js